import { createRef, useEffect, useReducer } from "react";
import { RenderChip } from "./RenderChip";
import { buildChipsArrays } from "./businessLogic";
import { ChipContainer } from "./styles";

export const ChipManager = ({
  id,
  data,
  handleDelete,
  handleClick,
  color,
  selectedColor = "primary",
  showIconSelectedIcon = true,
  direction,
  size,
  maxWidth,
  maxRows,
  ShowMoreComponent,
  ShowMoreProps,
  showMoreText,
  ...props
}) => {
  const chipContainerRef = createRef();
  const [state, setState] = useReducer((state, newState) => ({ ...state, ...newState }), {
    refs: [],
    chips: [],
    moreChips: [],
    open: false,
  });

  useEffect(() => {
    if (data && Array.isArray(data)) {
      setState({
        refs: Array(data.length)
          .fill()
          .map(() => createRef()),
      });
    }
  }, [data]);

  useEffect(() => {
    if (state.refs && data) {
      const { chips, moreChips } = buildChipsArrays(data, state.refs, chipContainerRef, maxRows);

      const updateState = {
        chips,
        moreChips,
        open: false,
      };

      if (state.chips.length !== chips.length) {
        updateState.chipsChange = true;
      }

      setState(updateState);
    }
  }, [state.refs, state.chipsChange]);

  return (
    <>
      <ChipContainer container direction={direction || "row"} ref={chipContainerRef}>
        {state.chips.map(({ cropped, ...chip }, index) => {
          return (
            <RenderChip
              id={`${id}-chip-${index}`}
              key={`${id}-chip-${index}`}
              data={chip}
              refProp={state.refs[index]}
              index={index}
              cropped={cropped}
              handleDelete={handleDelete}
              handleClick={handleClick}
              color={color}
              selectedColor={selectedColor}
              showIconSelectedIcon={showIconSelectedIcon}
              size={size}
              maxWidth={maxWidth?.toString()}
              {...props}
            />
          );
        })}
      </ChipContainer>

      {state.moreChips.length > 0 && (
        <ShowMoreComponent
          buttonText={`${state.moreChips.length} ${showMoreText}${state.moreChips.length > 1 ? "s" : ""}`}
          open={state.open || false}
          onClick={() => setState({ open: !state.open })}
          {...ShowMoreProps}
        >
          {state.moreChips.map(({ cropped, ...chip }, index) => (
            <RenderChip
              id={id}
              key={`${id}-chip-${index}`}
              data={chip}
              index={index}
              refProp={state.refs[index]}
              cropped={cropped}
              handleDelete={handleDelete}
              handleClick={handleClick}
              showIconSelectedIcon={showIconSelectedIcon}
              color={color}
              selectedColor={selectedColor}
              size={size}
              {...props}
            />
          ))}
        </ShowMoreComponent>
      )}
    </>
  );
};
